import vars from '../helpers';

let $main = null;
let $closeBtn = null;
let $openBtn = null;

let staticUrl = null;
let strGET = null;
let URLOpenGallery = null;
let URLCloseGallery = null;

function checkUrl() {
	if(window.location.href.indexOf('gallery') > -1) {
		staticUrl = staticUrl.replace('gallery', '');
		URLOpenGallery = staticUrl + 'gallery' + strGET;
		URLCloseGallery = staticUrl;

		$main.addClass('is-show-gallery is-not-transition');
		vars.$html.addClass('is-lock-scroll');

		setTimeout(() => {
			$main.addClass('is-open-gallery');
		}, 200);
	}
}

function open() {
	$main.addClass('is-show-gallery');
	vars.$html.addClass('is-lock-scroll');

	history.replaceState(null, "", URLOpenGallery)

	setTimeout(() => {
		$main.addClass('is-open-gallery');
	}, 200);
}

function close() {
	if ($main) {
		$main.removeClass('is-open-gallery is-not-transition');
		vars.$html.removeClass('is-lock-scroll');

		history.replaceState(null, "", URLCloseGallery);

		setTimeout(() => {
			$main.removeClass('is-show-gallery');
		}, 500);
	}
}

function init(container) {

	staticUrl = location.protocol + '//' + location.host + location.pathname;

	console.log('staticUrl 1', staticUrl);

	strGET = window.location.search.replace( 'gallery', '');

	URLOpenGallery = staticUrl + 'gallery' + strGET;
	URLCloseGallery = staticUrl;

	console.log('URLOpenGallery', URLOpenGallery);
	console.log('URLCloseGallery', URLCloseGallery);


	$main = $(container).find('.main');
	$closeBtn = $(container).find('.js-close-gallery');
	$openBtn = $(container).find('.js-open-gallery');

	$openBtn.on('click', open);
	$closeBtn.on('click', close);

	checkUrl();

	console.log('staticUrl 2', staticUrl);
	console.log('URLOpenGallery 2', URLOpenGallery);
	console.log('URLCloseGallery 2', URLCloseGallery);
}

function destroy() {
	if ($openBtn) {
		$openBtn.off('click', open);
		$openBtn = null;
	}

	if ($closeBtn) {
		$closeBtn.off('click', close);
		$closeBtn = null;
	}

	staticUrl = null;

	if ($main) {
		$main = null;
	}
}

export default {
	init,
	destroy,
	close,
}
